//GeneratorFlag:[NoChange]
import LetterTopic from './letter-topic';
import LetterTopicFilter from './letter-topic-filter';

export default {LetterTopic, LetterTopicFilter}
export{LetterTopic, LetterTopicFilter}